import { CircularProgress } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import { useContext, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import conditionsArrow from '../imgs/referral_conditions_arrow.png';
import '../mainscreen/items/promo/PromoItem.css';
import { ISession } from "../networking/Options";
import { ReferralAppContext } from "./ReferralApp";
import ReferralHeader from "./ReferralHeader";
import { IReferralInfo } from "./ReferralInfo";
import ReferralPromocodeCard from "./ReferralPromocodeCard";
import "./ReferralScreenHeaderSection.css";
import styles from './ReferralScreenHeaderSection.module.css';
interface IReferralScreenHeaderSectionProps {
	session?: ISession
	referral?: IReferralInfo
	isMobile: boolean
}

export default function ReferralScreenHeaderSection(props: IReferralScreenHeaderSectionProps) {
	const appContext = useContext(ReferralAppContext);

	const isRegistered = props.session?.user.is_registred ?? false;
	const avatarUrl = (props.session?.user.passport.avatar_url ?? "") + "/islands-68";
	const name = props.session?.user.passport.display_name ?? "";

	const hasPlus = props.session?.user.plus?.is_activated ?? false;
	const balance = appContext?.referral?.total_bonuses ?? 0;
	const hasPromo = appContext?.referral?.has_referral ?? false;
	const conditionsChatId = hasPlus ? "referral_plus" : "referral";
	const codeTemplate = appContext?.promocodeTemplate;

	function title() {
		if (isRegistered) {
			return "Обогащение за счёт друзей"
		} else {
			if (hasPlus) {
				return "Если копите баллы Плюса — приводите друзей в Драйв";
			} else {
				return "Обогащайтесь, не будучи в Драйве, и приводя в него друзей";
			}
		}
	}

	function description() {
		if (isRegistered) {
			if (hasPromo) {
				if (hasPlus) {
					return "Просто приводите их в Драйв: друзьям — скидка, вам — до 700 баллов Плюса с поездок каждого";
				} else {
					return "Просто приводите их в Драйв: друзьям — скидка, вам — до 700 бонусов или баллов Плюса, если включить его";
				}
			} else {
				if (hasPlus) {
					return "Создайте промокод и делитесь с друзьями: им — скидка 50% на первую поездку, вам — до 700 баллов Плюса";
				} else {
					return "Создайте промокод и делитесь с друзьями: им — скидка 50% на первую поездку, вам — до 700 баллов Плюса, если включите его";
				}
			}
		} else {
			if (hasPromo) {
				if (hasPlus) {
					return "Вас в Драйве нет, но промокод у вас есть.  Делитесь им: друзьям — скидка 50% на первую поездку, вам — до 700 баллов Плюса";
				} else {
					return "Вас в Драйве нет, но промокод у вас есть.  Делитесь им: друзьям — скидка 50% на первую поездку, вам — до 700 баллов Плюса, если включить его"
				}
			} else {
				if (hasPlus) {
					return "Создайте промокод и делитесь с друзьями: им — скидка 50% на первую поездку, вам — до 700 баллов Плюса";
				} else {
					return "Создайте промокод и делитесь с друзьями: им — скидка 50% на первую поездку, вам — до 700 баллов Плюса, если включите его";
				}
			}
		}
	}

	if (props.isMobile) {
		return <div className={styles.container_mobile}>
			<div className={styles.background}></div>
			<div className={styles.content_mobile}>
				<a href={window.location.href} className="Referral_promocode_header_section_mobile_logo">
					<img src="https://carsharing.s3.yandex.net/new-b2c-site/large_logo.png" />
				</a>
				<span className="Referral_promocode_header_section_mobile_title">
					{title()}
				</span>
				<span className="Referral_promocode_header_section_mobile_info">
					{description()}
				</span>
				<ReferralConditionsChat isForMobile={true} chatId={conditionsChatId} />
				{
					(hasPlus && balance > 0) &&
					<div style={{ zIndex: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
						<div className="Referral_promocode_header_section_plus_container_mobile">
							<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_302_2577)">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M24.7083 48.7083C37.895 48.7083 48.585 38.0183 48.585 24.8316C48.585 24.3126 48.5685 23.7975 48.5358 23.2868H35.1089L32.0189 38.0342H25.0666L28.2268 23.2868H14.4625L15.867 16.9665H29.561L32.6201 2.29688C30.144 1.42758 27.4814 0.954834 24.7083 0.954834C11.5215 0.954834 0.831543 11.6448 0.831543 24.8316C0.831543 38.0183 11.5215 48.7083 24.7083 48.7083ZM38.8807 5.61402C42.7089 8.44191 45.6621 12.3864 47.2593 16.9665H36.5134L38.8807 5.61402Z" fill="white" />
								</g>
								<defs>
									<clipPath id="clip0_302_2577">
										<rect width="47.7535" height="47.7535" fill="white" transform="translate(0.831543 0.954834)" />
									</clipPath>
								</defs>
							</svg>
							<span className="Referral_promocode_header_section_plus_container_balance_mobile">{balance}</span>
						</div>
						<span className="Referral_promocode_header_section_plus_container_subtitle">уже есть с друзей</span>
					</div>
				}
				<ReferralPromocodeCard />
			</div>
		</div>
	} else {
		return <div className={styles.container}>
			<ReferralHeader avatarUrl={avatarUrl} name={name} />
			<div className={styles.background}></div>
			<div className={styles.content}>
				<div className={styles.top_block}>
					<div className={styles.left_block}>
						<span className="Referral_promocode_header_section_left_block_title">{title()}</span>
						<span className="Referral_promocode_header_section_left_block_subtitle">
							{description()}
						</span>
						<ReferralConditionsChat isForMobile={false} chatId={conditionsChatId} />
					</div>
					{
						(hasPlus && balance > 0) &&
						<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
							<div className="Referral_promocode_header_section_plus_container">
								<svg width="92px" height="92px"><path fillRule="evenodd" clipRule="evenodd" d="M46.363 92.863C71.9332 92.863 92.6619 72.1344 92.6619 46.5642C92.6619 45.5579 92.6298 44.5591 92.5665 43.5687H66.5305L60.5389 72.165H47.0578L53.1855 43.5687H26.4956L29.2191 31.3131H55.7728L61.7046 2.86767C56.9033 1.18206 51.7402 0.265381 46.363 0.265381C20.7929 0.265381 0.064209 20.9941 0.064209 46.5642C0.064209 72.1344 20.7929 92.863 46.363 92.863ZM73.8444 9.29982C81.2676 14.7833 86.994 22.4319 90.0912 31.3131H69.254L73.8444 9.29982Z" fill="#ffffff"></path></svg>
								<span className="Referral_promocode_header_section_plus_container_balance">{balance}</span>
							</div>
							<span className="Referral_promocode_header_section_plus_container_subtitle">уже есть с друзей</span>
						</div>
					}
				</div>
				<ReferralPromocodeCard />
			</div>
		</div>
	}
}

function PlusLabelSmall() {
	return <span style={{ display: "inline", position: "relative", top: "5px" }}>
		<svg width="62" height="24" viewBox="0 0 62 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_98_3390)">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M14.2999 15.736L15.2502 11.2005H19.1538C19.1828 11.4629 19.1977 11.7295 19.1977 11.9996C19.1977 15.9756 15.9745 19.1988 11.9985 19.1988C8.02249 19.1988 4.79932 15.9756 4.79932 11.9996C4.79932 8.02359 8.02249 4.80042 11.9985 4.80042C12.776 4.80042 13.5247 4.92367 14.2262 5.1517L13.3928 9.04076H9.22448L8.77093 11.2005H12.9392L11.9674 15.736H14.2999ZM16.313 6.23598L15.7253 9.04076H18.5635C18.0601 7.92564 17.281 6.96174 16.313 6.23598Z" fill="url(#paint0_linear_98_3390)" />
			</g>
			<path d="M29.6458 13.2093C29.6458 13.7916 29.5419 14.3271 29.3339 14.8159C29.1259 15.2942 28.8295 15.7102 28.4448 16.0637C28.06 16.4069 27.6025 16.6773 27.0721 16.8748C26.5418 17.062 25.9543 17.1556 25.3095 17.1556C24.5608 17.1556 23.9421 17.0724 23.4534 16.906C22.975 16.7397 22.5591 16.5525 22.2055 16.3445V14.4259C22.5695 14.6651 22.9906 14.8939 23.469 15.1123C23.9577 15.3202 24.5244 15.4242 25.1692 15.4242C25.8971 15.4242 26.4482 15.2214 26.8226 14.8159C27.2073 14.4103 27.3997 13.906 27.3997 13.3029C27.3997 12.6997 27.2489 12.2214 26.9474 11.8678C26.6562 11.5143 26.1986 11.3375 25.5747 11.3375C25.19 11.3375 24.8728 11.3999 24.6232 11.5247C24.3736 11.6495 24.1865 11.7898 24.0617 11.9458H22.4239V5.81572H29.1155V7.62511H24.3425V10.1676C24.5192 10.0324 24.7532 9.91285 25.0444 9.80886C25.3355 9.69448 25.7151 9.63728 26.183 9.63728C27.2541 9.63728 28.0964 9.95445 28.7099 10.5888C29.3339 11.2127 29.6458 12.0862 29.6458 13.2093ZM35.5378 17.1556C34.8827 17.1556 34.2692 17.036 33.6972 16.7969C33.1357 16.5473 32.6418 16.1833 32.2154 15.705C31.7994 15.2162 31.4719 14.6131 31.2327 13.8956C30.9935 13.1781 30.874 12.3462 30.874 11.3999C30.874 10.4536 30.9935 9.62688 31.2327 8.91977C31.4719 8.20225 31.7994 7.60432 32.2154 7.12597C32.6418 6.64763 33.1357 6.28887 33.6972 6.0497C34.2692 5.80012 34.8827 5.67534 35.5378 5.67534C36.1929 5.67534 36.8065 5.79493 37.3784 6.0341C37.9503 6.27327 38.4443 6.63203 38.8602 7.11037C39.2762 7.58872 39.6037 8.18665 39.8429 8.90417C40.0821 9.61128 40.2017 10.4328 40.2017 11.3687C40.2017 12.3046 40.0821 13.1313 39.8429 13.8488C39.6037 14.5663 39.2762 15.1746 38.8602 15.6738C38.4443 16.1625 37.9503 16.5317 37.3784 16.7813C36.8065 17.0308 36.1929 17.1556 35.5378 17.1556ZM35.5222 15.4242C35.8758 15.4242 36.2033 15.3514 36.5049 15.2058C36.8065 15.0603 37.0664 14.8315 37.2848 14.5195C37.5032 14.1972 37.6748 13.7812 37.7996 13.2717C37.9243 12.7621 37.9867 12.1434 37.9867 11.4155C37.9867 10.6876 37.9243 10.0688 37.7996 9.55929C37.6748 9.03935 37.5032 8.6234 37.2848 8.31143C37.0664 7.98907 36.8065 7.7551 36.5049 7.60952C36.2033 7.46393 35.881 7.39114 35.5378 7.39114C35.1947 7.39114 34.8723 7.46393 34.5707 7.60952C34.2796 7.7551 34.0248 7.98907 33.8064 8.31143C33.588 8.6234 33.4165 9.03935 33.2917 9.55929C33.1669 10.0688 33.1045 10.6876 33.1045 11.4155C33.1045 12.1434 33.1669 12.7621 33.2917 13.2717C33.4165 13.7812 33.588 14.1972 33.8064 14.5195C34.0248 14.8315 34.2796 15.0603 34.5707 15.2058C34.8619 15.3514 35.1791 15.4242 35.5222 15.4242ZM44.0488 17.0464L50.1009 5.78453H51.9727L45.9206 17.0464H44.0488ZM46.9813 8.91977C46.9813 9.42931 46.9033 9.88165 46.7473 10.2768C46.6017 10.6616 46.3938 10.9891 46.1234 11.2595C45.8634 11.5299 45.5515 11.7378 45.1875 11.8834C44.8339 12.0186 44.4492 12.0862 44.0332 12.0862C43.6069 12.0862 43.2169 12.0238 42.8634 11.899C42.5098 11.7638 42.1978 11.5663 41.9275 11.3063C41.6675 11.0463 41.4647 10.724 41.3191 10.3392C41.1736 9.94405 41.1008 9.4917 41.1008 8.98216C41.1008 8.47262 41.1736 8.02547 41.3191 7.64071C41.4647 7.24556 41.6675 6.9128 41.9275 6.64243C42.1978 6.37206 42.5098 6.16928 42.8634 6.0341C43.2169 5.88851 43.6069 5.81572 44.0332 5.81572C44.4492 5.81572 44.8339 5.88331 45.1875 6.0185C45.5515 6.15368 45.8634 6.35126 46.1234 6.61123C46.3938 6.8712 46.6017 7.19356 46.7473 7.57832C46.9033 7.96308 46.9813 8.41022 46.9813 8.91977ZM42.9414 8.95096C42.9414 9.60609 43.0401 10.0688 43.2377 10.3392C43.4353 10.5992 43.7005 10.7292 44.0332 10.7292C44.366 10.7292 44.6312 10.5992 44.8287 10.3392C45.0367 10.0688 45.1407 9.60609 45.1407 8.95096C45.1407 8.30624 45.0367 7.85389 44.8287 7.59392C44.6312 7.32355 44.366 7.18836 44.0332 7.18836C43.7005 7.18836 43.4353 7.32355 43.2377 7.59392C43.0401 7.85389 42.9414 8.30624 42.9414 8.95096ZM54.9364 13.8332C54.9364 14.3427 54.8584 14.7951 54.7024 15.1902C54.5464 15.5854 54.3332 15.9182 54.0629 16.1885C53.8029 16.4485 53.4909 16.6513 53.127 16.7969C52.7734 16.932 52.3939 16.9996 51.9883 16.9996C51.562 16.9996 51.1668 16.9372 50.8029 16.8125C50.4493 16.6773 50.1373 16.4797 49.867 16.2197C49.607 15.9598 49.4042 15.6374 49.2586 15.2526C49.113 14.8575 49.0403 14.4051 49.0403 13.8956C49.0403 13.3861 49.113 12.9389 49.2586 12.5541C49.4042 12.159 49.607 11.8314 49.867 11.5715C50.1373 11.3011 50.4493 11.0983 50.8029 10.9631C51.1668 10.8175 51.562 10.7448 51.9883 10.7448C52.3939 10.7448 52.7734 10.8123 53.127 10.9475C53.4909 11.0723 53.8029 11.2647 54.0629 11.5247C54.3332 11.7846 54.5464 12.107 54.7024 12.4918C54.8584 12.8765 54.9364 13.3237 54.9364 13.8332ZM51.9883 12.1018C51.6556 12.1018 51.3852 12.237 51.1772 12.5074C50.9796 12.7673 50.8808 13.2197 50.8808 13.8644C50.8808 14.5195 50.9796 14.9823 51.1772 15.2526C51.3852 15.5126 51.6556 15.6426 51.9883 15.6426C52.3211 15.6426 52.5862 15.5126 52.7838 15.2526C52.9918 14.9823 53.0958 14.5195 53.0958 13.8644C53.0958 13.2197 52.9918 12.7673 52.7838 12.5074C52.5862 12.237 52.3211 12.1018 51.9883 12.1018Z" fill="url(#paint1_linear_98_3390)" />
			<defs>
				<linearGradient id="paint0_linear_98_3390" x1="4.79932" y1="11.0397" x2="19.1977" y2="11.0397" gradientUnits="userSpaceOnUse">
					<stop stop-color="#F74D63" />
					<stop offset="1" stop-color="#844FD0" />
				</linearGradient>
				<linearGradient id="paint1_linear_98_3390" x1="21.5972" y1="10.7996" x2="55.5972" y2="10.7996" gradientUnits="userSpaceOnUse">
					<stop stop-color="#7F45D1" />
					<stop offset="1" stop-color="#397DDB" />
				</linearGradient>
				<clipPath id="clip0_98_3390">
					<rect width="14.3983" height="14.3983" fill="white" transform="translate(4.79932 4.80042)" />
				</clipPath>
			</defs>
		</svg>
	</span>

}

function ConditionsButton({ onClick, isForMobile }: { onClick: () => void, isForMobile: boolean }) {
	if (isForMobile) {
		return <button className="Referral_promocode_header_section_left_block_conditions_button_mobile" onClick={e => onClick()}>
			Условия<img style={{ width: "18px", height: "10px", objectFit: "contain" }} src={conditionsArrow}></img>
		</button>
	} else {
		return <button className="Referral_promocode_header_section_left_block_conditions_button" onClick={e => onClick()}>
			Условия<img style={{ width: "24px", height: "16px", objectFit: "contain" }} src={conditionsArrow}></img>
		</button>

	}
}

function ReferralConditionsChat({ isForMobile, chatId }: { isForMobile: boolean, chatId: string }) {
	const [showChat, setShowChat] = useState(false);
	const [isChatLoading, setIsChatLoading] = useState(false)
	const history = useHistory();
	const { url } = useRouteMatch();

	const iframeSrc = `https://yandex.ru/drive/referral_chat/index.html?chat=${chatId}`;

	useEffect(() => {
		window.addEventListener("message", (event) => {
			if (event.data == "close_referral") {
				setShowChat(false);
			} else if (event.data == "content_loaded") {
				setIsChatLoading(false);
			}
		}, false);
	}, []);

	if (isForMobile) {
		return <>
			<ConditionsButton isForMobile={isForMobile} onClick={() => {
				history.push(`${window.location.pathname}/chat`);
				// setIsChatLoading(true);
				// setShowChat(true);
			}} />
			<Drawer anchor="bottom" open={showChat} onClose={(e) => setShowChat(false)}>
				<div style={{ width: "100vw", height: "90vh", backgroundColor: "#ffffff", border: "none" }}>
					{
						isChatLoading &&
						<div style={{ display: "flex", height: "100%", "justifyContent": "center", "alignItems": "center" }}>
							<CircularProgress />
						</div>
					}
					<iframe src={iframeSrc} style={{
						height: "100%",
						width: "100%",
						zIndex: 99,
						backgroundColor: "#ffffff",
						border: "none"
					}} />
				</div>
			</Drawer>
		</>
	} else {
		return <>
			<ConditionsButton isForMobile={isForMobile} onClick={() => {
				setIsChatLoading(true);
				setShowChat(true);
			}} />
			<Drawer anchor="right" open={showChat} onClose={(e) => setShowChat(false)}>
				<div style={{ width: "500px", backgroundColor: "#ffffff", border: "none" }}>
					<div className="Promo_Item_Right_Section">
						{/* <div style={{width: "100%", height: "60px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end"}}>
						<img className="Promo_Item_Right_Section_NavBar_Close" src={close}
							onClick={(e) => setShowChat(false)} />
					</div> */}
						{
							isChatLoading &&
							<div style={{ width: "100%", height: "100vh", display: "flex", "justifyContent": "center", "alignItems": "center" }}>
								<CircularProgress />
							</div>
						}
						<iframe src={iframeSrc} style={{
							height: "100vh",
							width: "100%",
							position: "absolute",
							zIndex: 99,
							backgroundColor: "#ffffff",
							border: "none"
						}} />
					</div>
				</div>
			</Drawer>
		</>
	}
}